// these strings are identical to those in the BE - DO NOT CHANGE THEM
// RagSearch/SearchArticles endpoint
enum EmbeddingType {
  ProductDocumentation = 'ProductDocumentation',
  StrategyDocumentation = 'StrategyDocumentation',
  Agency = 'Agency',
  PublicApi = 'PublicApi',
  AnalyticsAndInsights = 'AnalyticsAndInsights',
  DspDescription = 'DspDescription',
}

export {EmbeddingType};
